import { useMemo } from 'react';

interface Props {
  date: Date;
}

export default function MessageDate({ date }: Props) {
  const isToday = (_date: Date) => {
    const d = new Date(_date);
    const today = new Date();
    return d.getDate() === today.getDate();
  };

  // biome-ignore lint/correctness/useExhaustiveDependencies: legacy
  const content = useMemo(() => {
    const d = new Date(date);

    if (isToday(date)) {
      return d.toLocaleTimeString([], {
        hour: 'numeric',
        minute: 'numeric',
        hour12: true,
      });
    } else {
      return d.toLocaleDateString();
    }
  }, [date]);

  return <div className="min-w-fit">{content}</div>;
}
